import { render } from "./AuthHome.vue?vue&type=template&id=a3fa1a94"
import script from "./AuthHome.vue?vue&type=script&lang=js"
export * from "./AuthHome.vue?vue&type=script&lang=js"
script.render = render

export default script